import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Service from "../webservice/http";

// Async thunk to fetch permission details from the API
export const fetchPermissions = createAsyncThunk(
  "permission/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const services = new Service();
      const res = await services.get("api/access_control/permission_details/");

      if (res === "TypeError: Failed to fetch") {
        return rejectWithValue("Failed to fetch");
      }

      if (res.code === "token_not_valid") {
        return rejectWithValue("token_not_valid");
      }

      // console.log("✅ [Redux] Permission data saved to store:", res);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  permissionDetail: [], // the permission_detail array
  fullResponse: null, // the full API response
  loading: false,
  error: null,
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    clearPermissions: (state) => {
      state.permissionDetail = [];
      state.fullResponse = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.fullResponse = action.payload;
        state.permissionDetail = action.payload.permission_detail || [];
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
